import { useGetNetSuiteCountries } from 'shared/data/webApp/v1';

export const useNetSuiteCountries = () => {
    const { data, isLoading } = useGetNetSuiteCountries(
        {
            query: {
                pageSize: 1000,
            },
        },
        {
            staleTime: 1000 * 60,
        }
    );

    return {
        items: data?.values ?? [],
        isLoading,
    };
};
